import { ApprovalApprovableState, ApprovalCancellationReason } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

export const getApprovalStateStatusLabel = (status: ApprovalApprovableState) => {
  switch (status) {
    case ApprovalApprovableState.Approved:
      return $t('Approved')
    case ApprovalApprovableState.Rejected:
      return $t('Denied')
    case ApprovalApprovableState.Cancelled:
      return $t('Cancelled')
    case ApprovalApprovableState.Requested:
      return $t('Pending')
    default:
      return $t('Pending')
  }
}

/**
 * Get a human-readable label for a cancellation reason.
 */
export const getCancellationReasonLabel = (
  reason: ApprovalCancellationReason | null | undefined,
): string | null => {
  if (!reason) {
    return null
  }

  switch (reason) {
    case ApprovalCancellationReason.HireEnded:
      return $t('The hire has ended')
    case ApprovalCancellationReason.HireCancelled:
      return $t('The hire was cancelled')
    case ApprovalCancellationReason.JobClosed:
      return $t('The job was closed')
    case ApprovalCancellationReason.ApprovalRejected:
      return $t('Another approval in this workflow was rejected')
    case ApprovalCancellationReason.ClassificationRetriggered:
      return $t('The classification was re-triggered')
    case ApprovalCancellationReason.WorkflowRetriggered:
      return $t('The workflow was re-triggered')
    case ApprovalCancellationReason.ApprovableRemoved:
      return $t('The approvable item was removed')
    default:
      return null
  }
}
